import script from "./vecciniEditCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./vecciniEditCreate.vue?vue&type=script&setup=true&lang=ts"

import "./vecciniEditCreate.vue?vue&type=style&index=0&id=42cc56cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cc56cd"]])

export default __exports__